import React, {useEffect, useState} from 'react';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import {useTranslation} from 'react-i18next';
import Table from "./Table/Table";
import {Title} from "../../typography/Title";
import { useTheme } from '@mui/material/styles';
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import Button from "../../inputs/Button";

// Using inline styles for better compatibility
const useStyles = () => ({
    preWrap: {
        whiteSpace: 'pre-wrap',
    },
});

const SelectDialog = ({open, setOpen, onSelected}) => {
    const {t} = useTranslation();
    const classes = useStyles();

    const [saveEnabled, setSaveEnabled] = useState(false);
    const [selected, setSelected] = useState(null);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        if (!selected) {
            setSaveEnabled(false);
            return;
        }

        setSaveEnabled(true)
    }, [selected, setSaveEnabled]);


    const handleClose = () => {
        setOpen(false);
    };

    const handleSelect = (e) => {
        onSelected(selected);
        handleClose()
    };

    return (
        <Dialog
            open={open}
            aria-labelledby={t('select_canned')}
            aria-describedby={t('select_canned')}
            fullScreen={fullScreen}
            fullWidth
            maxWidth='lg'
        >
            <DialogTitle id="select-canned-title">{t('create_canned_title')}</DialogTitle>
            <DialogContent>
                <DialogContentText id="select-canned-description">
                </DialogContentText>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Table mode='select' setValue={setSelected} value={selected}/>
                    </Grid>
                    {selected &&
                    <Grid item xs={12} md={6}>
                        <Title>{selected.Title}</Title>
                        <Typography variant="body1" color="textPrimary" component="p" style={classes.preWrap}>
                            {selected.Message}
                        </Typography>
                    </Grid>
                    }
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    {t('close_btn')}
                </Button>
                <Button color="primary" variant='contained' disabled={!saveEnabled} onClick={handleSelect}>
                    {t('select_btn')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};


export default SelectDialog;